import { useEffect, useState } from "react";
import { toast } from "sonner";
import { RefreshCw } from "lucide-react";
import { adminApi, errMsg, fmt, fmtDate, STATUS_TR } from "@/lib/api";

const FILTERS = [["pending", "Bekleyen"], ["", "Tümü"], ["approved", "Onaylı"], ["rejected", "Reddedilen"], ["awaiting_payment", "Ödeme Bekleyen"]];

const Details = ({ t, kind }) => {
  if (t.method === "crypto")
    return (
      <div className="font-mono text-[12px] leading-5">
        <div><b className="text-white">{t.coin_amount} {t.coin}</b> @ ₺{fmt(t.rate)}</div>
        <div className="text-[var(--x-muted)] break-all">{t.address}</div>
        {t.tx_hash && <a href={`https://tronscan.org/#/transaction/${t.tx_hash}`} target="_blank" rel="noreferrer" className="text-[#7fb6ff] underline">TX: {t.tx_hash.slice(0, 14)}…</a>}
      </div>
    );
  return (
    <div className="text-[12px] leading-5">
      {kind === "withdrawals" ? (
        <><div className="font-bold">{t.holder} · {t.bank_name}</div><div className="font-mono text-[var(--x-muted)]">{t.iban}</div></>
      ) : (
        <div className="text-[var(--x-muted)]">{t.status === "pending" ? "Kullanıcı gönderimi yaptığını bildirdi" : "Havale/EFT"}</div>
      )}
    </div>
  );
};

export const AdminTx = ({ kind }) => {
  const [status, setStatus] = useState("pending");
  const [rows, setRows] = useState([]);
  const load = () => adminApi.get(`/admin/${kind}`, { params: { status } }).then((r) => setRows(r.data));
  useEffect(() => {
    load();
  }, [status]); // eslint-disable-line react-hooks/exhaustive-deps

  const act = async (id, action) => {
    try {
      const { data } = await adminApi.post(`/admin/${kind}/${id}/${action}`);
      toast.success(action === "check" ? `Durum: ${STATUS_TR[data.status]?.t || data.status}` : action === "approve" ? "Onaylandı" : "Reddedildi");
      load();
    } catch (e) {
      toast.error(errMsg(e));
    }
  };

  return (
    <div className="x-panel p-4">
      <div className="flex flex-wrap gap-2 mb-4 items-center">
        {FILTERS.filter(([k]) => kind === "deposits" || k !== "awaiting_payment").map(([k, l]) => (
          <button key={k || "all"} data-testid={`${kind}-filter-${k || "all"}`} onClick={() => setStatus(k)} className={`x-btn py-1.5 px-3 text-[13px] ${status === k ? "x-btn-primary" : "x-btn-secondary"}`}>{l}</button>
        ))}
        <button onClick={load} className="ml-auto p-2 rounded hover:bg-white/5" data-testid={`${kind}-refresh-btn`}><RefreshCw size={16} /></button>
      </div>
      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead><tr className="text-left text-[var(--x-muted)]">
            <th className="px-3 py-2">Kullanıcı</th><th className="px-3 py-2">Yöntem</th><th className="px-3 py-2 text-right">Tutar</th>
            <th className="px-3 py-2">Detay</th><th className="px-3 py-2">Durum</th><th className="px-3 py-2">Tarih</th><th className="px-3 py-2" />
          </tr></thead>
          <tbody>
            {rows.map((t) => {
              const st = STATUS_TR[t.status] || { t: t.status, c: "#fff" };
              const canAct = t.status === "pending" || (kind === "deposits" && ["awaiting_payment", "expired"].includes(t.status));
              return (
                <tr key={t.id} className="border-t border-white/5 align-top" data-testid={`${kind}-row-${t.id}`}>
                  <td className="px-3 py-2.5 font-bold">{t.username}</td>
                  <td className="px-3 py-2.5">{t.method === "crypto" ? `Kripto · ${t.coin}` : "Havale/EFT"}</td>
                  <td className="px-3 py-2.5 text-right font-bold tabular-nums">₺{fmt(t.amount_try)}</td>
                  <td className="px-3 py-2.5 max-w-[280px]"><Details t={t} kind={kind} /></td>
                  <td className="px-3 py-2.5 font-bold" style={{ color: st.c }}>{st.t}{t.approved_by === "tronscan" && <div className="text-[11px] text-[var(--x-muted)]">Otomatik</div>}</td>
                  <td className="px-3 py-2.5 text-[var(--x-muted)] whitespace-nowrap">{fmtDate(t.created_at)}</td>
                  <td className="px-3 py-2.5">
                    {canAct && (
                      <div className="flex gap-1.5 justify-end">
                        {kind === "deposits" && t.method === "crypto" && t.status === "pending" && (
                          <button data-testid={`${kind}-check-${t.id}`} onClick={() => act(t.id, "check")} className="x-btn x-btn-secondary px-2.5 py-1.5 text-[12px]">Kontrol</button>
                        )}
                        <button data-testid={`${kind}-approve-${t.id}`} onClick={() => act(t.id, "approve")} className="x-btn x-btn-green px-2.5 py-1.5 text-[12px]">Onayla</button>
                        <button data-testid={`${kind}-reject-${t.id}`} onClick={() => act(t.id, "reject")} className="x-btn x-btn-red px-2.5 py-1.5 text-[12px]">Reddet</button>
                      </div>
                    )}
                  </td>
                </tr>
              );
            })}
            {rows.length === 0 && <tr><td colSpan={7} className="text-center py-8 text-[var(--x-dim)]">Kayıt yok</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
};
